var canvas, zoom, cWidth = 2000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, sizeCrop, input, img;

var loader = jQuery('#customLoader'),
    cropper = "", aspectRatio, reCroper;

var sizeB1W = 236, sizeB1H = 228,
    sizeB2W = 790, sizeB2H = 765; 

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let backImg = document.querySelector("#background_image");
let backgroundImage = new fabric.Image(backImg, {
  left: 0,
  top: 0,
  scaleX: 2,
  scaleY: 2,
  selectable: false
});

window['canvas'] = new fabric.Canvas('canvas2',{
  width:cWidth,
  height:cHeight
});

window['canvas'].add(backgroundImage);
addModify(window['canvas']);

window['placeholderimg1'] = new fabric.Rect({
  left:168,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

const placeholderText1 = new fabric.Text('1', {
  left:168,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText1);

window['placeholderimg2'] = new fabric.Rect({
  left:446,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

const placeholderText2 = new fabric.Text('2', {
  left:446,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText2);

window['placeholderimg3'] = new fabric.Rect({
  left: 722,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText3 = new fabric.Text('3', {
  left:722,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText3);

window['placeholderimg4'] = new fabric.Rect({
  left: 999,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText4 = new fabric.Text('4', {
  left:999,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText4);

window['placeholderimg5'] = new fabric.Rect({
  left: 1277,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText5 = new fabric.Text('5', {
  left:1277,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText5);

window['placeholderimg6'] = new fabric.Rect({
  left: 1553,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText6 = new fabric.Text('6', {
  left:1553,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText6);

window['placeholderimg7'] = new fabric.Rect({
  left: 1833,
  top: 164,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText7 = new fabric.Text('7', {
  left:1833,
  top: 164,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText7);

window['placeholderimg8'] = new fabric.Rect({
  left: 168,
  top: 432,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText8 = new fabric.Text('8', {
  left:168,
  top: 432,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText8);

window['placeholderimg9'] = new fabric.Rect({
  left: 446,
  top: 432,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText9 = new fabric.Text('9', {
  left:446,
  top: 432,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText9);

window['placeholderimg10'] = new fabric.Rect({
  left: 1001,
  top: 700.5,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText10 = new fabric.Text('10', {
  left:1001,
  top: 700.5,
  fontSize: 45,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText10);

window['placeholderimg11'] = new fabric.Rect({
  left: 1553,
  top: 432,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText11 = new fabric.Text('11', {
  left:1553,
  top: 432,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText11);

window['placeholderimg12'] = new fabric.Rect({
  left: 1833,
  top: 432,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText12 = new fabric.Text('12', {
  left:1833,
  top: 432,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText12);

window['placeholderimg13'] = new fabric.Rect({
  left: 168,
  top: 700,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText13 = new fabric.Text('13', {
  left:168,
  top: 700,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText13);

window['placeholderimg14'] = new fabric.Rect({
  left: 446,
  top: 700,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText14 = new fabric.Text('14', {
  left:446,
  top: 700,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText14);

window['placeholderimg15'] = new fabric.Rect({
  left: 1553,
  top: 700,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText15 = new fabric.Text('15', {
  left:1553,
  top: 700,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText15);

window['placeholderimg16'] = new fabric.Rect({
  left: 1833,
  top: 700,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText16 = new fabric.Text('16', {
  left:1833,
  top: 700,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText16);

window['placeholderimg17'] = new fabric.Rect({
  left: 168,
  top: 968,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText17 = new fabric.Text('17', {
  left:168,
  top: 968,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText17);

window['placeholderimg18'] = new fabric.Rect({
  left: 446,
  top: 968,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText18 = new fabric.Text('18', {
  left:446,
  top: 968,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText18);

window['placeholderimg19'] = new fabric.Rect({
  left: 1553,
  top: 968,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText19 = new fabric.Text('19', {
  left:1553,
  top: 968,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText19);

window['placeholderimg20'] = new fabric.Rect({
  left: 1833,
  top: 968,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText20 = new fabric.Text('20', {
  left:1833,
  top: 968,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText20);

window['placeholderimg21'] = new fabric.Rect({
  left: 168,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText21 = new fabric.Text('21', {
  left:168,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText21);

window['placeholderimg22'] = new fabric.Rect({
  left: 446,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText22 = new fabric.Text('22', {
  left:446,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText22);

window['placeholderimg23'] = new fabric.Rect({
  left: 722,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText23 = new fabric.Text('23', {
  left:722,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText23);

window['placeholderimg24'] = new fabric.Rect({
  left: 999,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText24 = new fabric.Text('24', {
  left:999,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText24);

window['placeholderimg25'] = new fabric.Rect({
  left: 1277,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText25 = new fabric.Text('25', {
  left:1277,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText25);

window['placeholderimg26'] = new fabric.Rect({
  left: 1553,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText26 = new fabric.Text('26', {
  left:1553,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText26);

window['placeholderimg27'] = new fabric.Rect({
  left: 1833,
  top: 1236,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText27 = new fabric.Text('27', {
  left:1833,
  top: 1236,
  fontSize: 35,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas'].add(placeholderText27);


window['canvas'].add(window['placeholderimg1'], window['placeholderimg2'], window['placeholderimg3'], window['placeholderimg4'], window['placeholderimg5'], window['placeholderimg6'],
                      window['placeholderimg7'], window['placeholderimg8'], window['placeholderimg9'], window['placeholderimg10'], window['placeholderimg11'], window['placeholderimg12'],
                      window['placeholderimg13'], window['placeholderimg14'], window['placeholderimg15'], window['placeholderimg16'], window['placeholderimg17'], window['placeholderimg18'],
                      window['placeholderimg19'], window['placeholderimg20'], window['placeholderimg21'], window['placeholderimg22'], window['placeholderimg23'], window['placeholderimg24'],
                      window['placeholderimg25'], window['placeholderimg26'], window['placeholderimg27']);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg1'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_second').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg2'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_third').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg3'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fourth').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg4'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fifth').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg5'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_sixth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg6'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_seventh').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg7'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_eight').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg8'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});


document.getElementById('image_upload_ninth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg9'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_tenth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB2H;
  img = window['placeholderimg10'];
  sizeCrop = '1.03';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_eleventh').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg11'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twelfth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg12'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_thirteenth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg13'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fourteenth').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg14'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_fifteen').addEventListener('change',function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg15'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_sixteen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg16'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_seventeen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg17'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_eighteen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg18'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});


document.getElementById('image_upload_ninteen').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg19'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twenty').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg20'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentyone').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg21'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentytwo').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg22'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentythree').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg23'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentyfour').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg24'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentyfive').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg25'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentysix').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg26'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

document.getElementById('image_upload_twentyseven').addEventListener('change', function(e){
  canvas = window['canvas'];
  available_height = sizeB1H;
  img = window['placeholderimg27'];
  sizeCrop = '1.04';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;

  canvas.on('object:added', function(e){
    object = e.target;
    object.set({
      selectable:false,
      originX:"center",
      originY:"center",
    });
    canvas.renderAll();
  });
}


window['text55Page'] = new fabric.Text('@tasweer.com.pk',{
  left: 1885,
  top: 1368,
  fontSize: 16,
  fontFamily: 'Baloo2',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas'].add(window['text55Page']);